import React from 'react'
import { useTranslation } from 'react-i18next'
import { PaypalBackgroundColorType } from 'common/components/entities/paypal-rest-button'
import { SelectNew } from 'src/editor/shared/ui-lib/select-new/select-new'

const colors: Record<PaypalBackgroundColorType, string> = {
  blue: 'entity_settings.paypal.blue',
  black: 'entity_settings.paypal.black',
  gold: 'entity_settings.paypal.gold',
  silver: 'entity_settings.paypal.silver',
  white: 'entity_settings.paypal.white',
}

interface PaypalBackgroundColorProps {
  color?: PaypalBackgroundColorType
  update: (val: PaypalBackgroundColorType) => void
}

export const PaypalBackgroundColor = ({
  color = 'blue',
  update,
}: PaypalBackgroundColorProps) => {
  const { t } = useTranslation()

  return (
    <SelectNew
      labelText="bg color"
      options={Object.entries(colors).map(([color, label]) => ({
        value: color,
        label: t(label),
      }))}
      selectedOption={{
        value: color,
        label: t(colors[color]),
      }}
      onChange={option => update(option?.value as PaypalBackgroundColorType)}
      isMulti={false}
    />
  )
}
